<template>
    <div class="msg-banner-wrapper">
        <a v-bind:href="link" target="_blank">
            <div class="msg-banner">
                <div class="icon-box">
                    <slot name="icon">icon</slot>
                </div>
                <div class="message">
                    <label v-if="text" class="coss">{{ text }}</label>
                    <slot v-else name="message">message</slot>
                </div>
                <div v-if="link" class="chevron">
                    <i class="zmdi zmdi-chevron-right"></i>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
// a link can be passed through the "link" prop
// simple text can be passed through "text" prop
// zmdi icons can be passed in as a slot by adding slot="icon" as an attribute to the child element
// more compicated text can be passed in as a slot by adding slot="message" as an attribute to the child element

export default {
    name: 'MsgBanner',
    props: ['link', 'text']
}
</script>

<style scoped>
a{
    text-decoration: none;
}
.msg-banner-wrapper{
    margin-bottom: 1rem;
}
.msg-banner{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: stretch;
    background-color: #ffffff;
    border: 1px solid var(--gray3);
    border-radius: 0.5rem;
}
.icon-box{
    padding: 0 0.25rem;
    background: var(--orange2);
    border-top-left-radius: 0.5rem;
	border-bottom-left-radius: 0.5rem;
    display: flex;
    align-items: center;
}
.icon-box i.zmdi{
    color: #ffffff;
    width: 3rem;
    font-size: 1.5rem;
}
.message{
    margin-left: 1rem;
    margin-right: 1rem;
    padding: 0.5rem 0;
    line-height: 1.1;
}
.message label{
    cursor: pointer;
}
.coss.gray1{
    color: var(--gray1);
}
.chevron{
    margin-left: auto;
    width: 2rem;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    text-align: center;
}
</style>
